import { FOODS } from '@/lib/foods'
import { useI18n } from '@/hooks/useI18n'
import { FoodTable } from '@/components/FoodTable'

export function Foods() {
  const { t, fmt } = useI18n()
  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <header>
        <h1 className="font-display text-[34px] font-normal tracking-tightish text-gray-900">{t.foods.title}</h1>
        <p className="mt-1 text-[13.5px] text-gray-500">{fmt(t.foods.subtitle, { count: FOODS.length })}</p>
      </header>
      <FoodTable />
    </div>
  )
}
